import { render } from "./SaidaManual.vue?vue&type=template&id=5e9559ed&scoped=true"
import script from "./SaidaManual.vue?vue&type=script&lang=js"
export * from "./SaidaManual.vue?vue&type=script&lang=js"

import "./SaidaManual.vue?vue&type=style&index=0&id=5e9559ed&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9559ed"]])

export default __exports__